import repository from '@/repositories/Repository'

const resource = '/api/upload_file'
const itemResource = '/api/item'
const customerGroupResource = '/api/customer-group'
const cardResource = '/api/card'

function urlSafe(value) {
  return encodeURIComponent(value)
}

export default {
  issueUploadUrl(filename) {
    return repository.giggle
      .post(`${resource}`, filename, {
        headers: { 'Content-Type': 'application/json' },
      })
      .then(r => r.data)
  },
  upload(url, file) {
    return repository.rawHttp
      .put(url, file, {
        headers: { 'Content-Type': 'application/octet-stream' },
      })
      .then(r => r.data)
  },
  loadFile(id, schema) {
    return repository.giggle
      .post(`${resource}/${id}`, schema, {
        headers: { 'Content-Type': 'application/json' },
      })
      .then(r => r.data)
  },
  // TODO これは別リポジトリか？
  loadItemFile(id, company) {
    return repository.giggle
      .post(`${itemResource}/load/${id}?company=${urlSafe(company)}`, '', {
        headers: { 'Content-Type': 'application/json' },
      })
      .then(r => r.data)
  },
  // TODO お邪魔します
  loadCardFile(id, includeOriginalCode) {
    return repository.giggle
      .post(
        `${customerGroupResource}/card/${id}?includeOriginalCode=${includeOriginalCode}`,
        '',
        {
          headers: { 'Content-Type': 'application/json' },
        },
      )
      .then(r => r.data)
  },
  // TODO お邪魔します2
  loadCustomerFile(id, includeOriginalCode) {
    return repository.giggle
      .post(
        `${cardResource}/customer/${id}?includeOriginalCode=${includeOriginalCode}`,
        '',
        {
          headers: { 'Content-Type': 'application/json' },
        },
      )
      .then(r => r.data)
  },
  // fetchFile(id, dataType) {
  //   if (!validDataType.has(dataType)) {
  //     throw new Error(`Not a valid data type: ${dataType}`)
  //   }

  //   return repository.giggle
  //     .get(`${resource}/${dataType}/${id}`, undefined, {
  //       headers: { 'Content-Type': 'application/octet-stream' },
  //     })
  //     .then(r => r.data)
  // },
  // fetchFiles(dataType) {
  //   if (!validDataType.has(dataType)) {
  //     throw new Error(`Not a valid data type: ${dataType}`)
  //   }

  //   return repository.giggle
  //     .get(`${resource}/${dataType}`, undefined, {
  //       headers: { 'Content-Type': 'application/octet-stream' },
  //     })
  //     .then(r => r.data)
  // },
}
